import { SizeOptions } from '../../../../types/types'
import { SelectOption } from '../../AstraSelect'
import { MultiValueProps } from '../types/types'
import { AstraMultiSelectMultiValue } from './AstraMultiSelectMultiValue'

export type AstraMultiSelectGroupedMultiValueProps<T> = {
    data: MultiValueProps<T>['data']
    size: SizeOptions
    groups: Array<{ label: string; options: SelectOption<T>[] }>
    fullySelectedGroups: Set<string>
    valueToGroupLabel: Map<T, string>
    selectedOptions: SelectOption<T>[]
    removeProps: MultiValueProps<T>['removeProps']
    isDisabled?: MultiValueProps<T>['isDisabled']
    readOnly?: boolean
    onChange?: (values: SelectOption<T>[]) => void
}

export const AstraMultiSelectGroupedMultiValue = <T,>({
    data,
    size,
    groups,
    fullySelectedGroups,
    valueToGroupLabel,
    selectedOptions,
    removeProps,
    isDisabled,
    readOnly,
    onChange,
}: AstraMultiSelectGroupedMultiValueProps<T>) => {
    const groupLabel = valueToGroupLabel.get(data.value)

    if (groupLabel && fullySelectedGroups.has(groupLabel)) {
        const selectedGroup = groups.find(group => group.label === groupLabel)
        if (selectedGroup) {
            const [firstValue] = selectedGroup.options
            if (data.value !== firstValue?.value) return null
            const groupValueSet = new Set(selectedGroup.options.map(option => option.value))

            const handleRemoveGroup = () => {
                const remaining = selectedOptions.filter(selectedOption => !groupValueSet.has(selectedOption.value))
                onChange?.(remaining)
            }

            return (
                <AstraMultiSelectMultiValue
                    label={groupLabel}
                    removeProps={{ ...removeProps, onClick: handleRemoveGroup }}
                    size={size}
                    isDisabled={isDisabled}
                    readOnly={readOnly}
                />
            )
        }
    }

    return <AstraMultiSelectMultiValue label={data.label} removeProps={removeProps} size={size} isDisabled={isDisabled} readOnly={readOnly} />
}
